<!--
    COMPONENTE PARA SELECAO DE ITEM PARA VENDA VAREJO



- FALTA PERMITIR INCLUSAO DE PRODUTOS QUANDO NAO ENCONTRAR
- QUANDO O CODIGO DO ITEM PESQUISADO FOR IGUAL AO TEXTO DA PESQUISA, CARREGAR DIRETAMENTE NO PEDIDO

-->

<script>
import { formatValue } from "../shared/utils";
import { VueOfflineMixin } from "vue-offline";
import { VueOfflineStorage } from "vue-offline";

export default {
  props: {
    value: {},
    disabled: Boolean,
    addButton: Boolean,
    exibePreco: { type: Boolean, default: true },
    tabelaPreco: String,
    balanca: { type: Object },
    simple: Boolean,
    newQt: Number,
    showQt: Boolean
  },

  mixins: [VueOfflineMixin],

  data() {
    return {
      textSearch: "",
      inicio: true,
      noList: true,
      showList: false,
      originalTop: 0,

      isChoosing: true,
      modoCodigoBarra: true,
      modoInfoQtd: false,
      modoView: false,

      quantidade: 1,

      selectedIndex: 0,
      selected: {},

      items: [],
      itemssearch: [],

      vbalanca: {},

      crud: ""
    };
  },

  computed: {
    itemList: function () {
      return this.itemssearch;
    },

    metadata: function () {
      return this.$store.getters.getEntities.metadata;
    },

    pesquisarPlaceholder: function () {
      if (this.modoInfoQtd) return "Informe a Quantidade...";
      if (this.modoView) return "Informe o código para consulta...";
      if (this.modoCodigoBarra && !this.modoView)
        return "Informe o código para incluir...";
      return "Informe a descrição ou código...";
    }
  },

  filters: {
    format: function (value) {
      return formatValue(value, 4);
    }
  },

  methods: {
    handleBack() {
      if (this.modoCodigoBarra && this.modoView) {
        this.modoView = false;
        return;
      }
      if (this.modoCodigoBarra && !this.modoView) {
        this.modoCodigoBarra = false;
      }
    },
    handlePressf9(shortcut) {
      if (shortcut) {
        this.modoCodigoBarra = true;
        this.modoView = true;
        return;
      }
      if (this.modoCodigoBarra) {
        this.modoCodigoBarra = false
        this.modoView = true;
      }
      else
        if (!this.modoCodigoBarra) {
          this.modoCodigoBarra = true;
          this.modoView = false;
        }
    },
    handleisView() { },
    existe(coditem) {
      //CHECA SE O ITEM JÁ FOI LANCADO NO PEDIDO
      if (this.params && this.params.pedvit) {
        let obj = this.params.pedvit.find(o => o.coditem === coditem);
        if (obj) {
          return true;
        } else {
          return false;
        }
      } else return false;
    },

    handleEsc() {
      if (this.modoInfoQtd) {
        this.modoInfoQtd = false;
        this.quantidade = 1;
      }

      if (!this.showList && this.selected.nome) {
        this.isChoosing = false;
      } else {
        this.showList = false;
        this.textSearch = "";
        this.$refs.pesquisa.focus();
      }
    },

    handleKeyDown() {
      let listItems = document.getElementById("listitem");
      let array = Array.from(listItems.getElementsByClassName("active"));
      if (!array) {
        array = Array.from(listItems)
      }

      listItems.scrollBy(0, array[0].clientHeight);

      //TECLA PARA BAIXO
      if (this.itemList.length > 0) {
        if (this.selectedIndex >= (this.itemList.length - 1)) {
          this.selectedIndex = this.itemList.length - 1;
        } else {
          this.selectedIndex = this.selectedIndex + 1;
        }
        console.log(this.itemList.length)
        console.log(this.selectedIndex)
      }
    },

    handleKeyUp() {
      // TECLA PARA CIMA
      let listItems = document.getElementById("listitem");
      let array = Array.from(listItems.getElementsByClassName("active"));

      if (!array) {
        array = Array.from(listItems)
      }

      if (this.selectedIndex >= 1) {
        listItems.scrollBy(0, -array[0].clientHeight);
      }

      if (this.itemList.length > 0) {
        if (this.selectedIndex < 1) {
          this.selectedIndex = 0;
        } else {
          this.selectedIndex = this.selectedIndex - 1;
        }
        console.log(this.itemList.length)
        console.log(this.selectedIndex)

      }
    },

    focus() {
      this.$refs.pesquisa.focus();
    },

    closeForm() {
      this.$emit("closeform");
    },

    handleBlur() {
      //this.showList = false
    },

    handleChange() {
      // if (!this.textSearch) {
      //     this.showList = false
      //     return
      // }
    },

    setQtd() {
      let text = this.textSearch.toUpperCase();

      this.quantidade = parseFloat(text);

      this.modoInfoQtd = false;

      this.handleEsc();
    },

    handleEnter() {
      if (/^\*\d+$/.test(this.textSearch)) {
        const numero = this.textSearch.substring(1);
        this.$emit("defineQt", parseFloat(numero));
      }
      if (this.modoInfoQtd) {
        this.setQtd();
      } else if (this.modoCodigoBarra || this.modoView) {
        this.search();
      } else {
        if (this.textSearch) {
          this.handleSelectItem();
        }
      }
      this.textSearch = "";
    },

    handleInformarQuantidade() {
      this.modoInfoQtd = true;
    },

    handleSelectItem(index) {
      //AO SELECIONAR UM ITEM
      if (index) {
        this.selectedIndex = index;
      }
      if (this.itemList.length > 0) {
        this.selected = this.itemList[this.selectedIndex];
        this.selected.quantidade = this.quantidade;

        if (this.vbalanca.codigo) {
          if (this.vbalanca.barras_peso_ou_valor == "P") {
            this.selected.quantidade = this.vbalanca.valor;
          } else {
            this.selected.vlrtab = this.vbalanca.valor;
          }
        }

        this.showList = false;
        this.isChoosing = false;

        this.quantidade = 1;
        this.$emit("input", this.selected.coditem);
        this.$emit("onselect", this.selected);

        if (this.modoView) {
          this.$emit("setView", this.selected);
        }
        this.focusControl();
      }
    },

    search() {
      this.inicio = false;

      let self = this;

      if (!this.textSearch) {
        this.showList = false;
        return;
      }
      this.itemssearch = [];

      let text = this.textSearch.toUpperCase();
      this.vbalanca = {};


      if (this.modoCodigoBarra) {
        if (
          this.balanca &&
          this.balanca.numero_identificacao &&
          this.balanca.tamanhobarra &&
          this.balanca.inicio_codigo &&
          this.balanca.fim_codigo
        ) {
          // balanca: {
          //    numero_identificacao: null,
          // tamanhobarra: null,
          // inicio_codigo: null,
          // fim_codigo: null,
          // inicio_valor: null,
          // fim_valor: null,
          // barras_peso_ou_valor: null,
          //     qtd_casas_valor: null,
          // }
          console.log('balanca')
          if (text.length == this.balanca.tamanhobarra) {
            console.log(text.substring(0, 1))
            console.log(this.balanca.numero_identificacao)
            if (text.substring(0, 1) == this.balanca.numero_identificacao) {
              console.log(text)
              let codigo = text.substring(
                this.balanca.inicio_codigo,
                this.balanca.fim_codigo
              );
              console.log(codigo)
              let valor = parseFloat(
                text.substring(
                  this.balanca.inicio_valor,
                  this.balanca.fim_valor
                )
              );
              console.log(valor)
              if (this.balanca.qtd_casas_valor == 4) {
                valor = valor * 0.0001;
              } else if (this.balanca.qtd_casas_valor == 3) {
                valor = valor * 0.001;
              } else {
                valor = valor * 0.01;
              }

              this.vbalanca.codigo = codigo;
              this.vbalanca.valor = valor;
              this.vbalanca.barras_peso_ou_valor = this.balanca.barras_peso_ou_valor;

              console.log(this.vbalanca)

              this.filter =
                '{"codbarras":{"$or":[{"$eq":"' +
                codigo +
                '"},{"codigo":{"$eq":"' +
                codigo +
                '"}}]}}';
            }
          } else {
            this.filter =
              '{"codbarras":{"$or":[{"$eq":"' +
              text +
              '"},{"codigo":{"$eq":"' +
              text +
              '"}}]}}';
          }
        } else {
          this.filter =
            '{"codbarras":{"$or":[{"$eq":"' +
            text +
            '"},{"codigo":{"$eq":"' +
            text +
            '"}}]}}';
        }
      } else {
        this.filter =
          '{"descricao":{"$or":[{"$like":"%25' +
          text +
          '%25"},{"codigo":{"$like":"%25' +
          text +
          '%25"}},{"codbarras":{"$like":"%25' +
          text +
          '%25"}}]}}';
      }

      this.loadData().then(function () {
        self.itemssearch = self.$store.getters.getItemSalesVarejoList;
        if (self.modoView || self.modoCodigoBarra) {
          if (self.itemssearch && self.itemssearch.length > 0) {
            self.itemssearch[0].quantidade = self.quantidade;
            self.$emit("setView", self.itemssearch);
          }
        }
        if (self.modoCodigoBarra && !self.modoView) {
          if (self.itemssearch && self.itemssearch.length > 0) {
            self.handleSelectItem(0);
          } else {
            this.$erpToastError("Item não encontrado");
          }
        }
      });
    },

    async loadData() {
      await this.$store.dispatch("loadItemSalesVarejo", {
        codtabpre: this.tabelaPreco,
        filter: this.filter
      });

      this.selectedIndex = 0;
    },

    focusControl: function (event) {
      this.textSearch = "";
      this.$refs.pesquisa.focus();
    },

    handlerChangeBarCodeMode() {
      VueOfflineStorage.set("barCodeMode", this.modoCodigoBarra);
    }
  },

  watch: {
    modoCodigoBarra: function (value) {
      // QUANDO O MODOCODIGOBARRA FOR FALSO O MODOVIEW PRECISA SER ALTERADO PARA FALSO
      if (this.modoView && value == false) {
        this.modoView = value;
      }
    },
    textSearch: function () {
      let vm = this;
      if (this.keytimer) {
        clearTimeout(this.keytimer);
      }
      if (!this.modoCodigoBarra && !this.modoInfoQtd) {
        this.keytimer = setTimeout(function () {
          vm.search();
        }, 300);
      }
    },

    itemList: function () {
      if (this.inicio) {
        return;
      }
      if (!this.itemList.length || this.modoCodigoBarra) {
        this.noList = true;
        this.showList = false;
      } else {
        this.noList = false;
        this.showList = true;
      }
      return this.itemssearch;
    }
  },

  components: {
    // CustomerForm,
  },

  created() {
    if (this.value) {
      this.loadData(this.value);
    }

    this.$nextTick(function () {
      //const rect = this.$refs.pesquisa.getBoundingClientRect();
      jQuery('[data-toggle="tooltip"]').tooltip();
    });
  },

  mounted() {
    this.originalTop = this.$el.getBoundingClientRect().top;
    if (
      VueOfflineStorage &&
      VueOfflineStorage.keys &&
      VueOfflineStorage.keys.includes("barCodeMode")
    ) {
      this.modoCodigoBarra = VueOfflineStorage.get("barCodeMode");
    }
  }
};
</script>

<template>
  <div class="row mb-2">
    <div class="col-md-12 col-12">
      <div class="float-left">
        <!-- <span class="data-list" data-toggle="tooltip" title="F2 - informar Quantidade"> Qtd: <strong>{{ quantidade | format }}</strong> X</span> -->
        <strong v-if="modoCodigoBarra" style="font-size:12px">Codigo de Barras | Balança</strong>
        <strong style="font-size:12px" v-else>Codigo ou Descrição</strong>
      </div>
      <div class="float-right">
        <strong style="font-size:12px">Use F9 para leitor de código de barras</strong>
        <!-- <input-checkbox
          label="Use F9 para leitor de código de barras"
          v-model="modoCodigoBarra"
          :value-checked="true"
          :value-unchecked="false"
          @input="handlerChangeBarCodeMode()"
          :customStyle="'font-size:11px!important'"
        ></input-checkbox> -->
      </div>
    </div>
    <div style="position: relative;min-width: 30vw; width: 100%; z-index: 1; background-color: white;">
      <div class="col-md-12 col-12">
        <div class="input-group">
          <input type="text"
            style="font-size:17px!important; padding: 11px;border-radius:5px; border: 1px solid #C9D3DD;" ref="pesquisa"
            class="col-12 vd-input px-3 py-2" id="search" autocomplete="off" :placeholder="pesquisarPlaceholder"
            v-model="textSearch" @blur="handleBlur()" @change="handleChange()" @keyup.esc="handleEsc()"
            @keyup.enter="handleEnter()" @keyup.down="handleKeyDown()" @keyup.up="handleKeyUp()"
            @keyup.120="handlePressf9()" @keyup.27="handleBack()" />
        </div>
        <div class="col-md-12 col-12">
          <!-- <span
            class="text-secondary float-left"
            style="font-size:12px"
            v-if="!modoCodigoBarra"
            >F9 - Para Codigo de Barras ou Balança</span
          >
          <span class="text-secondary float-left" style="font-size:12px" v-else
            >ESC - Código do Item ou Descrição</span
          > -->
          <span class="text-secondary float-right" style="font-size: 12px; margin-left: auto" v-if="showQt">
            Quantidade: {{ newQt }}
          </span>
          <span class="text-secondary float-right" style="font-size: 12px" v-else>
            Use * para informar a quantidade (Ex *5)
          </span>
        </div>

        <!-- <v-label v-if="addButton" label="" title-add-button="Cadastrar" @clickAdd="handleIncluirCliente()"></v-label> -->

        <div class="col-md-12 col-12">
          <ul v-if="showList" class="typeahead dropdown-part col" id="listitem"
            style="display: block; height:62vh; overflow:auto!important;">
            <li v-for="(item, index) in itemList" :class="{ active: index == selectedIndex }" :id="'ilistitem' + index"
              :key="index" @click="handleSelectItem(index)">
              <div class="row" style="gap: 30px">
                <div class="col-md-1 col-2 text-center">
                  <img v-if="item.url" :src="item.url" class="mx-auto d-block img-thumbnail" alt="Logotipo"
                    style="max-width: 45px; max-height: 45px; cursor: pointer;"
                    @click="handleAnexosForm(item.coditem, item.descricao)" />
                  <i v-if="!item.url" class="fa fa-camera d-block"
                    style="font-size: 25px; color: silver; cursor: pointer"
                    @click="handleAnexosForm(item.coditem, item.descricao)"></i>
                </div>
                <div class="col-md-6 col-8">
                  <span class=""><strong>{{ item.descricao }}</strong> -
                    {{ item.codigo }}</span>
                  <span v-if="existe(item.coditem)" class="badge badge-yellow-outline">Adicionado</span>
                </div>
                <div class="col-md-3 col-4" v-show="exibePreco">
                  <span class="">R$ <strong>{{ item.vlrtab | format }}</strong></span>
                </div>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>

  <!-- <div class="nb-modal-scrollable" v-if="showPartForm">
            <div class="container nb-modal-scrollable-container">
                <div class="nb-modal-scrollable-body">
                    <customer-form :crud="crud" :index="codpart" @closeform="closePartForm"></customer-form>
                </div>
            </div>
        </div> -->
</template>

<style scoped>
.typeahead {
  z-index: 1051;
  margin-top: 2px;
  -webkit-border-radius: 4px;
  -moz-border-radius: 4px;
  border-radius: 4px;
  box-shadow: 0 5px 10px rgba(0, 0, 0, 0.2);
  color: #383838;
}

.typeahead li {
  border-bottom: 1px solid #efefef;
  padding: 15px;
}

.typeahead li:hover {
  color: white !important;
  background-color: #1d5b96;
  cursor: pointer;
}

.typeahead .active {
  color: white !important;
  background-color: #1d5b96;
}

.typeahead * {
  white-space: normal !important;
}

* {
  margin: 0px;
  padding: 0px;
  text-decoration: none;
  outline: none !important;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
}

.typeahead-data {
  white-space: normal !important;
}

.typeahead-title {
  display: inline-block;
  max-width: 100%;
  margin-bottom: 5px;
  margin-right: 5px;
  font-size: 18px;
}

li {
  line-height: 20px;
}

.dropdown-part {
  position: absolute;
  top: 100%;
  left: 0;
  z-index: 1000;
  display: none;
  float: left;
  min-width: 160px;
  padding: 5px 0;
  margin: 2px 0 0;
  list-style: none;
  background-color: #fff;
  border: 1px solid #ccc;
  border: 1px solid rgba(0, 0, 0, 0.2);
  *border-right-width: 2px;
  *border-bottom-width: 2px;
  -webkit-border-radius: 6px;
  -moz-border-radius: 6px;
  border-radius: 6px;
  -webkit-box-shadow: 0 5px 10px rgba(0, 0, 0, 0.2);
  -moz-box-shadow: 0 5px 10px rgba(0, 0, 0, 0.2);
  box-shadow: 0 5px 10px rgba(0, 0, 0, 0.2);
  -webkit-background-clip: padding-box;
  -moz-background-clip: padding;
  background-clip: padding-box;
}
</style>



// WEBPACK FOOTER //
// src/forms-varejo/varejo-add-item.vue